"use client";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../../components/ui/table";

const apiUrl = process.env.REACT_APP_API_URL;

const getOutletId = (outlet: any): string =>
  String(
    outlet?.venueoutlet_id ??
      outlet?.venue_outlet_id ??
      outlet?.outlet_id ??
      outlet?.id ??
      ""
  );

const getOutletName = (outlet: any): string =>
  String(outlet?.venue_outlet_name ?? outlet?.name ?? outlet?.label ?? "-");

const getOutletStatus = (outlet: any): string => {
  const raw = outlet?.status;
  if (raw === 1 || raw === "1" || raw === "current") return "Current";
  if (raw === 2 || raw === "2" || raw === "non-current" || raw === "non_current") {
    return "Non-Current";
  }
  if (typeof raw === "string" && raw.trim()) return raw;
  return "-";
};

export default function VenueOutletsTable() {
  const [venueOutlets, setVenueOutlets] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchVenueOutlets = async () => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${apiUrl}/venue_outlets`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
    });

    const result = await response.json();
    if (!response.ok || result?.success === false) {
      throw new Error(result?.message || `HTTP error! status: ${response.status}`);
    }

    if (Array.isArray(result?.venue_outlets)) {
      setVenueOutlets(result.venue_outlets);
      return;
    }
    if (Array.isArray(result?.venueOutlets)) {
      setVenueOutlets(result.venueOutlets);
      return;
    }
    if (Array.isArray(result?.data)) {
      setVenueOutlets(result.data);
      return;
    }
    setVenueOutlets([]);
  };

  useEffect(() => {
    fetchVenueOutlets().catch(() => setVenueOutlets([]));
  }, []);

  const handleRowClick = (outlet: any) => {
    navigate("/update-venue-outlet", { state: { outlet } });
  };

  return (
    <Table>
      <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Venue Outlet Name
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
      <TableBody>
        {venueOutlets.map((outlet, index) => {
          const id = getOutletId(outlet) || `outlet-${index}`;
          return (
            <TableRow
              key={id}
              className="cursor-pointer hover:bg-[#ffffa3]"
              onClick={() => handleRowClick(outlet)}
            >
              <TableCell className="whitespace-normal border border-gray-100 px-4 py-4 text-xs font-normal text-gray-800 dark:border-white/[0.05] dark:text-white/90">
                {getOutletName(outlet)}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
